var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 7.49935V5.41602C1.66602 3.34102 3.34102 1.66602 5.41602 1.66602H7.49935",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.66602H14.5833C16.6583 1.66602 18.3333 3.34102 18.3333 5.41602V7.49935",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 13.334V14.584C18.334 16.659 16.659 18.334 14.584 18.334H13.334",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 18.3333H5.41602C3.34102 18.3333 1.66602 16.6583 1.66602 14.5833V12.5",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75065 5.83398V7.50065C8.75065 8.33398 8.33398 8.75065 7.50065 8.75065H5.83398C5.00065 8.75065 4.58398 8.33398 4.58398 7.50065V5.83398C4.58398 5.00065 5.00065 4.58398 5.83398 4.58398H7.50065C8.33398 4.58398 8.75065 5.00065 8.75065 5.83398Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 5.83398V7.50065C15.4167 8.33398 15 8.75065 14.1667 8.75065H12.5C11.6667 8.75065 11.25 8.33398 11.25 7.50065V5.83398C11.25 5.00065 11.6667 4.58398 12.5 4.58398H14.1667C15 4.58398 15.4167 5.00065 15.4167 5.83398Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75065 12.5V14.1667C8.75065 15 8.33398 15.4167 7.50065 15.4167H5.83398C5.00065 15.4167 4.58398 15 4.58398 14.1667V12.5C4.58398 11.6667 5.00065 11.25 5.83398 11.25H7.50065C8.33398 11.25 8.75065 11.6667 8.75065 12.5Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 12.5V14.1667C15.4167 15 15 15.4167 14.1667 15.4167H12.5C11.6667 15.4167 11.25 15 11.25 14.1667V12.5C11.25 11.6667 11.6667 11.25 12.5 11.25H14.1667C15 11.25 15.4167 11.6667 15.4167 12.5Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.ecf30ca70fd2d5e24e0c37a5c6afc20f.svg";
export { ForwardRef as ReactComponent };